import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MoneyBleedIcon, PriceTagIcon } from './PlumbingIcons';
export function DiagnosticoSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-dark" data-id="element-114">
      <div className="max-w-6xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-116">
          <h2 className="text-4xl md:text-5xl font-black text-gold tracking-tight uppercase" data-id="element-117">
            El Diagnóstico
          </h2>
          <div className="w-24 h-1 bg-emerald mx-auto mt-6 rounded-full shadow-neon-green" data-id="element-118" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-119">
          {/* Card 1 */}
          <motion.div variants={cardVariants} className="group relative bg-dark-card rounded-2xl p-10 border border-emerald/50 shadow-neon-green transition-all duration-300 hover:shadow-neon-green-lg hover:-translate-y-2" data-id="element-120">
            <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-121">
              <MoneyBleedIcon size={120} className="text-emerald" data-id="element-122" />
            </div>

            <div className="relative z-10" data-id="element-123">
              <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-8 border border-emerald/30" data-id="element-124">
                <MoneyBleedIcon size={32} className="text-emerald animate-pulse-glow" data-id="element-125" />
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-126">
                Hemorragia de Dinero
              </h3>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-127">
                Gastas en camiones y equipo, pero tus bahías están vacías porque{' '}
                <span className="text-white font-semibold" data-id="element-128">
                  nadie te encuentra en Google.
                </span>
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={cardVariants} className="group relative bg-dark-card rounded-2xl p-10 border border-emerald/50 shadow-neon-green transition-all duration-300 hover:shadow-neon-green-lg hover:-translate-y-2" data-id="element-129">
            <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-130">
              <PriceTagIcon size={120} className="text-emerald" data-id="element-131" />
            </div>

            <div className="relative z-10" data-id="element-132">
              <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-8 border border-emerald/30" data-id="element-133">
                <PriceTagIcon size={32} className="text-emerald animate-pulse-glow" data-id="element-134" />
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-135">
                Infección de Precios Bajos
              </h3>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-136">
                Solo atraes clientes que regatean por $10. Necesitas pacientes
                que{' '}
                <span className="text-white font-semibold" data-id="element-137">
                  valoren la urgencia y la calidad.
                </span>
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}